import { render, staticRenderFns } from "./researchForm.vue?vue&type=template&id=f54ecb0e&scoped=true"
import script from "./researchForm.vue?vue&type=script&lang=js"
export * from "./researchForm.vue?vue&type=script&lang=js"
import style0 from "./researchForm.vue?vue&type=style&index=0&id=f54ecb0e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ecb0e",
  null
  
)

export default component.exports